var escape = require("../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".engineImg[data-v-5286dcea],.engineVideo[data-v-5286dcea]{height:calc(100% + 15px)}.error-color-bg[data-v-5286dcea]{background:rgba(4,61,105,.6)}.error-image-bg[data-v-5286dcea]{background-image:url(" + escape(require("../../assets/images/xinjiang_bg.jpg")) + ");background-repeat:no-repeat;background-size:100% 100%}.model-view[data-v-5286dcea]{height:100vh!important;-webkit-transform:scale(1);transform:scale(1);-webkit-transform-origin:0 0;transform-origin:0 0}.model-view .el-loading-mask[data-v-5286dcea]{background-color:#577681!important}.model-view.no-loading-icon[data-v-5286dcea]  .el-loading-spinner{display:none}", ""]);

// exports
